import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { modifiers, sizes, } from '../CounterBadge/constants';
const containerStyles = css `
  display:flex;
`;
const variationStyles = {
    [modifiers.alternateLight]: {
        backgroundColor: theme.colors.surfaceSemanticWarningSubtle,
        color: theme.colors.gray700,
    },
    [modifiers.alternateStrong]: {
        backgroundColor: theme.colors.surfaceSemanticWarningHover,
        color: theme.colors.gray100,
    },
    [modifiers.negativeStrong]: {
        backgroundColor: theme.colors.surfaceSemanticError,
        color: theme.colors.gray100,
    },
    [modifiers.negativeLight]: {
        backgroundColor: theme.colors.surfaceSemanticErrorSubtle,
        color: theme.colors.gray700,
    },
    [modifiers.positiveStrong]: {
        backgroundColor: theme.colors.surfaceSystemTertiaryInverse,
        color: theme.colors.accent100,
    },
    [modifiers.positiveLight]: {
        backgroundColor: theme.colors.surfaceSemanticSuccessSubtle,
        color: theme.colors.accent700,
    },
};
const sizeStyles = {
    [sizes.medium]: theme.spacing.x6,
    [sizes.small]: theme.spacing.x4,
};
const defaultProps = {
    modifier: modifiers.positiveLight,
    size: sizes.medium,
};
const CounterBadge = ({ modifier = defaultProps.modifier, size = defaultProps.size, value, }) => {
    const shape = useMemo(() => (value.length === 1
        ? 'circle'
        : 'pill'), [
        value,
    ]);
    const counterBadgeStyles = useMemo(() => (css `
        ${theme.typeStyles.captionSmallStyles}
        align-items: center;
        background-color: ${variationStyles[modifier].backgroundColor};
        border-color: ${theme.colors.gray100};
        border-style: solid;
        border-width: ${styleUtils.rem(1)};
        box-sizing: border-box;
        color: ${variationStyles[modifier].color};
        display: flex;
        height: ${sizeStyles[size]};
        justify-content: center;
        line-height: 1;

        ${shape === 'circle' && css `
          border-radius: 50%;
          flex-shrink: 1;
          width: ${sizeStyles[size]};
        `}
        ${shape === 'pill' && css `
          border-radius: ${styleUtils.rem(100)};
        `}

        ${size === 'small' && css `
          padding-bottom: ${styleUtils.rem(1)};
          padding-left: ${theme.spacing.base};
          padding-right: ${theme.spacing.base};
          padding-top: ${styleUtils.rem(1)};
        `}
        ${size === 'medium' && css `
          padding-bottom: ${theme.spacing.base};
          padding-left: ${theme.spacing.x2};
          padding-right: ${theme.spacing.x2};
          padding-top: ${theme.spacing.base};
        `}
      `), [
        modifier,
        size,
        shape,
    ]);
    return (_jsx("div", Object.assign({ css: containerStyles }, { children: _jsx("div", Object.assign({ css: counterBadgeStyles }, { children: value })) })));
};
const MemoizedCounterBadge = memo(CounterBadge);
export { MemoizedCounterBadge as CounterBadge };
// MC-1068 Temporary hack for Storybook.
export default CounterBadge;
